export const PERMS = {
    READ: 'report_carrier_usage.read',
    EXPORT: 'report_carrier_usage.export',
}
